import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const FileDocs = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M21.071 9H2.93A1.929 1.929 0 0 0 1 10.929V21.07C1 22.137 1.863 23 2.929 23H21.07A1.929 1.929 0 0 0 23 21.071V10.93A1.929 1.929 0 0 0 21.071 9zM21 21H3V11h18v10z" />
    <path d="M9 17h6a1 1 0 0 0 1-1v-3h-2v2h-4v-2H8v3a1 1 0 0 0 1 1zM6 7h12a1 1 0 1 0 0-2H6a1 1 0 0 0 0 2zM8 3h8a1 1 0 1 0 0-2H8a1 1 0 0 0 0 2z" />
  </SvgIcon>
);

export default FileDocs;
